import { render, staticRenderFns } from "./AupairResources.vue?vue&type=template&id=8ec8b2a2&"
import script from "./AupairResources.vue?vue&type=script&lang=js&"
export * from "./AupairResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports